import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { scrollToId } from "@/lib/scroll";
import { useLang } from "@/i18n";

const LegalDialog = ({ label, title, body, testid }) => {
  const { t } = useLang();
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          data-testid={testid}
          className="text-xs uppercase tracking-[0.2em] text-neutral-500 hover:text-[#D4AF37] font-bold transition-colors duration-300 cursor-pointer"
        >
          {label}
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#121212] border-white/10 rounded-none text-white max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl uppercase tracking-wide">
            {title}
          </DialogTitle>
          <DialogDescription className="text-neutral-500 text-xs uppercase tracking-[0.2em]">
            {t.footer.updated}
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[60vh] pr-4">
          <p className="whitespace-pre-line text-sm text-neutral-400 leading-relaxed">
            {body}
          </p>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

const Footer = () => {
  const { t } = useLang();
  const f = t.footer;

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505] overflow-hidden">
      <div className="container-x pt-16 pb-8">
        <button
          data-testid="footer-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.6 })}
          className="font-display uppercase leading-[0.8] tracking-tighter text-[18vw] lg:text-[13vw] text-white/10 hover:text-white/20 transition-colors duration-500 cursor-pointer block text-left"
        >
          FIT<span className="text-[#D91624]/30">BERSAMA</span>
        </button>

        <div className="mt-10 flex flex-col md:flex-row md:items-center justify-between gap-8 border-t border-white/10 pt-8">
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {t.nav.links.map((n) => (
              <button
                key={n.id}
                data-testid={`footer-nav-${n.id}`}
                onClick={() => scrollToId(n.id)}
                className="text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-white font-bold transition-colors duration-300 cursor-pointer"
              >
                {n.label}
              </button>
            ))}
          </nav>
          <div className="flex items-center gap-6">
            <LegalDialog label={f.privacy} title={f.privacy} body={f.privacyBody} testid="footer-privacy-btn" />
            <LegalDialog label={f.terms} title={f.terms} body={f.termsBody} testid="footer-terms-btn" />
          </div>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-neutral-600">
          <p>{f.rights}</p>
          <p>{f.tagline}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
